export default __webpack_public_path__ + "static/media/logo.ae41f5f7.png";